<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El alto clero poblano y el proceso de Independencia</h2>
    <img @click="imageClicked(0)" src="galerias/independencia/g7/G7.jpg" class="mainphoto"/>
    <p class="photo-description">Retrato del obispo Antonio Joaquín Pérez Martínez. Autor Manuel López Guerrero, Óleo sobre tela. Col San Pedro Museo de Arte.</p>
    <p>La amistad que surgió hacia 1820, entre Agustín de Iturbide y el obispo poblano Antonio Joaquín Pérez Martínez, uno de los políticos más importantes de la época, tuvo como consecuencia que el movimiento de independencia estuviera influenciado por su pensamiento político. Esta cercanía permitió el recibimiento en el Palacio Episcopal de Puebla, entre el 2 y el 5 de agosto de 1821, de Iturbide y el Ejército Trigarante en su camino a Córdoba para la firma de los tratados que reconocería la independencia de Nueva España.</p>
    <p>El obispo impulsó la libertad de prensa, la difusión del Plan de Iguala en Puebla, y favoreció el apoyo de varios sectores de la sociedad. Además, la noticia del apoyo a Iturbide por parte del alto clero poblano, fue recibida como una señal inequívoca del logro de la Independencia, ya que la Diócesis con sede en Puebla era fundamental en la vida de la Nueva España, e incluso, después de la consumación, lo seguirá siendo dentro del México Independiente.</p>
    <p>El domingo 5 de agosto de 1821, Iturbide juró el Plan de Iguala ante el Cabildo de la ciudad de Puebla, y desde ahí le dio lectura. Así, Puebla fue la primera ciudad independiente de la Nueva España y la que difundió abiertamente las ideas contenidas en el Plan de Iguala.</p>
    <p>La Ciudad de Puebla fue respetada por Morelos y por Mariano Matamoros dentro de sus estrategias militares, debido a que era una ciudad episcopal, es decir, era la sede del obispo.</p>
    <p>El 28 de septiembre de 1821, al firmarse el Acta de Independencia del Imperio Mexicano, el segundo de los firmantes, solo después de la firma de Iturbide es la del obispo poblano Antonio Joaquín Pérez Martínez.</p>
    <h5>VER MÁS</h5>
    <p>Consulta el documento digitalizado del Plan de Iguala en este link:<ul><li><a target="_blank" href="http://bdmx.mx/documento/galeria/plan-independencia-plan-iguala">bdmx.mx</a></li></ul></p>
  </div>
</template>

<script>
export default {
  name: "Sala3m8",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
